<div class="brand-logo">
    <img *ngIf="!brandLogoWhite" src="assets/svg/icons/brand-logo.svg" alt="Klinq" />
    <img *ngIf="brandLogoWhite" src="assets/svg/icons/brand-logo-light.svg" alt="brand icon" />
</div>
